




























import { namespace } from 'vuex-class';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CART } from '@/store/types';
import { Cart } from '@/services/cart/model/cart';
import { Step } from '@/cart-page/header/Step';
import CartPageHeader from '@/cart-page/header/CartPageHeader.vue';
import ConfirmationStepView from '@/cart-page/confirmation/ConfirmationStepView.vue';
import FairDeliveryStepView from '@/fair-cart/FairDeliveryStepView.vue';
import { Fair } from '@/services/fair/Fair';
import { CommonOrderDetailService } from '@/services/order/CommonOrderDetailService';
import { FairOrderDetailService } from '@/services/order/FairOrderDetailService';
import FairCartStepView from '@/fair-cart/FairCartStepView.vue';

const cart = namespace(CART);

@Component({
  components: {
    FairCartStepView,
    CartPageHeader,
    FairDeliveryStepView,
    ConfirmationStepView
  }
})
export default class FairCartPage extends Vue {

  get fairModel(): Fair {
    return Fair.fromJson(this.localFairModel);
  }

  public steps = Step;
  @Prop({required: false, default: ''})
  public localCartInfo: string;
  @Prop({required: false, default: 'de'})
  public localLocale: string;
  @Prop()
  public localFairModel: string;

  @cart.State('cart')
  public cart: Cart;

  @cart.State('step')
  private step: Step;

  private orderDetailService = CommonOrderDetailService.singleton();
  private fairOderDetailService = FairOrderDetailService.singleton();

  public beforeDestroy() {
    this.orderDetailService.resetCheckoutState();
    this.fairOderDetailService.resetCheckoutState();
  }

  @Watch('step')
  private onStepChange() {
    this.$nextTick(() => {
      window.scrollTo(0, 0);
    });
  }
}
